clients-info
  h4 { opts.name }
  .client_code { opts.client_code }
  script(type="typescript").
    this.mixin('base');
